/**
 * @generated SignedSource<<2531f1f9491bcc3e1b687a0f21ee6b00>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useHandleTemplateChangeIssueTemplate$data = {
  readonly __typename: "IssueTemplate";
  readonly __id: string;
  readonly assignees: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"AssigneePickerAssignee" | "AssigneePickerSharedAssignee">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly body: string | null | undefined;
  readonly filename: string;
  readonly labels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"LabelPickerLabel">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly title: string | null | undefined;
  readonly type: {
    readonly " $fragmentSpreads": FragmentRefs<"IssueTypePickerIssueType">;
  } | null | undefined;
  readonly " $fragmentType": "useHandleTemplateChangeIssueTemplate";
};
export type useHandleTemplateChangeIssueTemplate$key = {
  readonly " $data"?: useHandleTemplateChangeIssueTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHandleTemplateChangeIssueTemplate">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useHandleTemplateChangeIssueTemplate"
};

(node as any).hash = "53ad086477e7aa080e2b371001dc6e1c";

export default node;
